import {
  Icons,
  NavItemVertical
} from '@eggplant/pattern-library'
import {
  SPACES,
  renderLinkTo,
  routeLabels
} from '@eggplant/routing'

interface Props {
  isCollapsed: boolean
}

const SpaceNavItem = ({
  isCollapsed
}: Props) =>
  <NavItemVertical
    icon={<Icons.CircledSpace aria-hidden />}
    isCollapsed={isCollapsed}
    label={routeLabels[SPACES]}
  >
    {renderLinkTo(SPACES)}
  </NavItemVertical>

export default SpaceNavItem
